import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import { Svg } from "../../../../elements";

var Spinner = function Spinner(props) {
  var _props$iconTitle = props.iconTitle,
      iconTitle = _props$iconTitle === void 0 ? "Loading" : _props$iconTitle;
  var getClassName = getClassNameFactory(Spinner.displayName);
  var SpinnerSvg = /*#__PURE__*/React.createElement("svg", {
    className: getClassName({
      descendantName: "progress"
    }),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    role: "presentation"
  }, /*#__PURE__*/React.createElement("circle", {
    className: getClassName({
      descendantName: "background"
    }),
    cx: "8px",
    cy: "8px",
    r: "7px"
  }), /*#__PURE__*/React.createElement("circle", {
    className: getClassName({
      descendantName: "indeterminate-indicator-1"
    }),
    cx: "8px",
    cy: "8px",
    r: "7px"
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(Svg, {
    label: iconTitle,
    height: 64,
    width: 64
  }, SpinnerSvg));
};

Spinner.displayName = "Spinner";
export default Spinner;